<div [class.data-container]="!isFormReadonly" class="ui-g data-content">
  <div *ngIf="!isFormReadonly" class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 form-column margin-align">
    <div class="page-heading text-uppercase">
      <h4 class="margin-header-align text-uppercase">{{ 'data.page-title' | translate }}</h4>
    </div>
    <hr />
  </div>

  <div
    *ngIf="technicianInfoFormGroup"
    [formGroup]="technicianInfoFormGroup"
    class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 content-section">
    <div class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-12 ui-sm-12 ui-xs-12 sub-section">
      <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 form-column margin-align">
        <p class="margin-header-align">{{ 'basic-profile.fields.base_data' | translate }}</p>
        <hr />
      </div>

      <div class="ui-g-12 margin-align" *ngIf="technicianInfoFormGroup.get('tax_id')">
        <label class="ui-g-5 text-right-align field-label" for="data-input-tax-id">
          {{ 'basic-profile.fields.tax_id' | translate }}
        </label>
        <input
          (change)="getCompanyDetails()"
          class="h4-button-and-field ui-input pInputText field-width"
          formControlName="tax_id"
          id="data-input-tax-id"
          pInputText
          size="30"
          type="text" />
      </div>

      <div class="ui-g-12 margin-align" *ngIf="technicianInfoFormGroup.get('sweeping_district_number')">
        <label class="ui-g-5 text-right-align field-label required" for="data-input-sweeping-district-number">
          {{ 'basic-profile.fields.sweeping-district-number' | translate }}
        </label>
        <input
          class="h4-button-and-field ui-input pInputText field-width"
          formControlName="sweeping_district_number"
          id="data-input-sweeping-district-number"
          pInputText
          size="30"
          type="text" />
      </div>

      <div class="ui-g-12 margin-align" *ngIf="technicianInfoFormGroup.get('company_name')">
        <label class="ui-g-5 text-right-align field-label required" for="data-input-company">
          {{ 'basic-profile.fields.company' | translate }}
        </label>
        <input
          class="h4-button-and-field ui-input pInputText field-width"
          formControlName="company_name"
          id="data-input-company"
          pInputText
          size="30"
          type="text" />
      </div>

      <div class="ui-g-12 margin-align" *ngIf="technicianInfoFormGroup.get('street')">
        <label class="ui-g-5 text-right-align field-label required" for="data-input-street">
          {{ 'basic-profile.fields.street' | translate }}
        </label>
        <input
          class="h4-button-and-field ui-input pInputText field-width"
          formControlName="street"
          id="data-input-street"
          pInputText
          size="30"
          type="text" />
      </div>

      <div class="ui-g-12 margin-align" *ngIf="technicianInfoFormGroup.get('street_number')">
        <label class="ui-g-5 text-right-align field-label required" for="data-input-street-number">
          {{ 'basic-profile.fields.street_number' | translate }}
        </label>
        <input
          class="h4-button-and-field ui-input pInputText field-width"
          formControlName="street_number"
          id="data-input-street-number"
          pInputText
          size="30"
          type="text" />
      </div>

      <div class="ui-g-12 margin-align" *ngIf="technicianInfoFormGroup.get('postcode')">
        <label class="ui-g-5 text-right-align field-label required" for="data-input-postcode">
          {{ 'basic-profile.fields.postcode' | translate }}
        </label>
        <input
          [appNumber]="true"
          class="h4-button-and-field ui-input pInputText field-width"
          formControlName="postcode"
          id="data-input-postcode"
          pInputText
          size="30" />
      </div>

      <div class="ui-g-12 margin-align" *ngIf="technicianInfoFormGroup.get('city')">
        <label class="ui-g-5 text-right-align field-label required" for="data-input-city">
          {{ 'basic-profile.fields.city' | translate }}
        </label>
        <input
          class="h4-button-and-field ui-input pInputText field-width"
          formControlName="city"
          id="data-input-city"
          pInputText
          size="30"
          type="text" />
      </div>

      <div class="ui-g-12 margin-align" *ngIf="technicianInfoFormGroup.get('telephone')">
        <label class="ui-g-5 text-right-align field-label required" for="data-input-company-telephone">
          {{ 'basic-profile.fields.telephone_central' | translate }}
        </label>
        <input
          class="h4-button-and-field ui-input pInputText field-width"
          formControlName="telephone"
          id="data-input-company-telephone"
          pInputText
          size="30"
          [appNumber]="true" />
      </div>

      <div class="ui-g-12 margin-align" *ngIf="technicianInfoFormGroup.get('ceo')">
        <label class="ui-g-5 text-right-align field-label required" for="data-input-ceo">
          {{ 'basic-profile.fields.ceo' | translate }}
        </label>
        <input
          class="h4-button-and-field ui-input pInputText field-width"
          formControlName="ceo"
          id="data-input-ceo"
          pInputText
          size="30"
          type="text" />
      </div>

      <ng-container *ngIf="technicianInfoFormGroup.get('headsubsidiary')">
        <div class="ui-g-12 margin-align radio-button-section">
          <label class="ui-g-5 field-label"></label>
          <p-radioButton
            [label]="'basic-profile.fields.headoffice' | translate"
            formControlName="headsubsidiary"
            id="data-options-headoffice"
            labelStyleClass="required"
            name="group"
            value="hauptbetrieb"></p-radioButton>
        </div>
        <div class="ui-g-12 margin-align radio-button-section">
          <label class="ui-g-5 field-label"></label>
          <p-radioButton
            [label]="'basic-profile.fields.subsidiary' | translate"
            formControlName="headsubsidiary"
            id="data-options-subsidiary"
            labelStyleClass="required"
            name="group"
            value="nebenbetrieb"></p-radioButton>
        </div>
        <div class="ui-g-12 margin-align radio-button-section" *ngIf="showAuxiliaryOption">
          <label class="ui-g-5 field-label"></label>
          <p-radioButton
            name="group"
            value="auxiliary_company"
            [label]="'basic-profile.fields.auxiliary' | translate"
            labelStyleClass="required"
            id="data-options-auxiliary"
            formControlName="headsubsidiary"></p-radioButton>
        </div>
      </ng-container>
    </div>

    <div class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-12 ui-sm-12 ui-xs-12 sub-section">
      <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 form-column margin-align">
        <p class="margin-header-align">{{ 'basic-profile.fields.technician-data' | translate }}</p>
        <hr />
      </div>

      <div class="ui-g-12 margin-align" *ngIf="technicianInfoFormGroup.get('technician_id')">
        <label class="ui-g-5 text-right-align field-label required" for="data-input-technician ID">
          {{ 'basic-profile.fields.technician_id' | translate }}
        </label>
        <input
          class="h4-button-and-field ui-input pInputText field-width"
          formControlName="technician_id"
          id="data-input-technician ID"
          pInputText
          size="30"
          readonly
          type="text" />
      </div>

      <div class="ui-g-12 margin-align" *ngIf="technicianInfoFormGroup.get('title')">
        <label class="ui-g-5 text-right-align field-label required" for="technician-title">
          {{ 'basic-profile.fields.title' | translate }}
        </label>
        <p-dropdown [options]="titles" formControlName="title" id="technician-title" placeholder="-Select-">
          <ng-template let-item pTemplate="selectedItem">
            <span class="drop-item-label">{{ 'lookup.' + titleKey + '.options.' + item['value'] + '.name' | translate }}</span>
          </ng-template>
          <ng-template let-option pTemplate="item">
            <div class="drop-item">
              <span class="drop-item-label">{{ 'lookup.' + titleKey + '.options.' + option['value'] + '.name' | translate }}</span>
            </div>
          </ng-template>
        </p-dropdown>
      </div>

      <div class="ui-g-12 margin-align" *ngIf="technicianInfoFormGroup.get('first_name')">
        <label class="ui-g-5 text-right-align field-label required" for="data-input-firstname">
          {{ 'basic-profile.fields.first_name' | translate }}
        </label>
        <input
          class="h4-button-and-field ui-input pInputText field-width"
          formControlName="first_name"
          id="data-input-firstname"
          pInputText
          size="30"
          type="text" />
      </div>

      <div class="ui-g-12 margin-align" *ngIf="technicianInfoFormGroup.get('last_name')">
        <label class="ui-g-5 text-right-align field-label required" for="data-input-lastname">
          {{ 'basic-profile.fields.name' | translate }}
        </label>
        <input
          class="h4-button-and-field ui-input pInputText field-width"
          formControlName="last_name"
          id="data-input-lastname"
          pInputText
          size="30"
          type="text" />
      </div>

      <div class="ui-g-12 margin-align" *ngIf="technicianInfoFormGroup.get('birthday')">
        <label class="ui-g-5 text-right-align field-label required" for="data-input-birthday">
          {{ 'basic-profile.fields.birthday' | translate }}
        </label>
        <p-calendar
          *ngIf="'app.calendar-settings' | translate"
          [dateFormat]="dateFormat.dateFormat"
          [monthNavigator]="true"
          [placeholder]="dateFormat.placeholder"
          [yearNavigator]="true"
          [locale]="'app.calendar-settings' | translate"
          dataType="string"
          formControlName="birthday"
          id="data-input-birthday"
          yearRange="1900:2080"></p-calendar>
      </div>

      <div class="ui-g-12 margin-align" *ngIf="technicianInfoFormGroup.get('user_telephone')">
        <label class="ui-g-5 text-right-align field-label required" for="data-input-telephone">
          {{ 'basic-profile.fields.telephone' | translate }}
        </label>
        <input
          [appNumber]="true"
          class="h4-button-and-field ui-input pInputText field-width"
          formControlName="user_telephone"
          id="data-input-telephone"
          pInputText
          size="30" />
      </div>
      <div class="ui-g-12 margin-align" *ngIf="technicianInfoFormGroup.get('user_mail')">
        <label class="ui-g-5 text-right-align field-label" [class.required]="myDataFormFields.isEmailRequired" for="data-input-mail">
          {{ 'basic-profile.fields.mail' | translate }}
        </label>
        <input
          class="h4-button-and-field ui-input pInputText field-width"
          formControlName="user_mail"
          id="data-input-mail"
          pInputText
          size="30"
          readonly />
      </div>
    </div>

    <div *ngIf="showActionButtons" class="ui-g-12 button-rows">
      <button
        (click)="confirmDataChange()"
        [disabled]="disableSubmitButton"
        class="submit-button"
        id="password-btn-submit"
        label="{{ 'change-password.submit-button-label' | translate }}"
        pButton
        type="button"></button>

      <button
        (click)="resetFormData()"
        [disabled]="technicianInfoFormGroup.untouched"
        class="cancel-button"
        id="password-btn-cancel"
        label="{{ 'change-password.cancel-button-label' | translate }}"
        pButton
        type="button"></button>
    </div>
  </div>
</div>

<p-confirmDialog #dataChangeDialog message="{{ 'data.data-change-confirmation-text' | translate }}" styleClass="netz-confirm-dialog">
  <p-footer>
    <button (click)="dataChangeDialog.accept()" label="{{ 'yes-button-label' | translate }}" pButton type="button"></button>
    <button (click)="dataChangeDialog.reject()" label="{{ 'no-button-label' | translate }}" pButton type="button"></button>
  </p-footer>
</p-confirmDialog>

<app-loader *ngIf="isLoading"></app-loader>
